// Generated file : do not modify

export enum ObjTypes
{
  NONE = 0,
  ABATTEMENT = 165,
  ACCIDENT_TRAVAIL = 1,
  ACCOUNT = 2,
  ACCOUNT_ALLOCATION = 173,
  ACCOUNT_ENTRY = 172,
  ACCOUNT_ENTRY_LINE = 174,
  ACTIVITE = 3,
  ACTUALITE = 110,
  ADMIN = 4,
  ADMIN_ATTRIB = 5,
  ADMIN_CHOIX = 6,
  ADMIN_CLASSE = 7,
  ADMIN_INFO = 9,
  ADRESSE = 13,
  AEM = 14,
  AEM_LIST = 136,
  AER = 177,
  AGETA = 138,
  APPRENTI = 99,
  ARTICLE_ITEM = 97,
  ATTESTATION = 164,
  ATTESTATION_DEF = 163,
  ATTESTATION_FISCALE = 109,
  AUTHORIZED_CREDIT = 178,
  BANK = 124,
  BANK_DAY = 159,
  BANK_LOG = 118,
  BILL = 15,
  BILL_ITEM = 16,
  BORDEREAU_CONGES_SPECTACLE = 137,
  BRANCHE = 17,
  BRANCHE_CONVENTION = 18,
  CADRE_EMBAUCHE = 133,
  CAISSE = 19,
  CART = 20,
  CARTE = 21,
  CATEGORIE_RETENUE = 22,
  CATEGORIE_SOCIO_PRO = 23,
  CHAT = 24,
  CHAT_ITEM = 25,
  CI_PERIOD = 135,
  CI_SESSION = 26,
  CIVILITE = 132,
  CLIENT = 27,
  CLIENT_SALARIE = 28,
  COLUMN_CONFIG = 114,
  COLUMN_FILTER = 116,
  COMPTA = 119,
  CONTACT = 29,
  CONTRAT = 30,
  CONTRAT_ARTICLE = 31,
  CONTRAT_TEMPLATE = 96,
  CONTROLE_SIGNATURE_MASSE_RESULT = 179,
  CONVENTION = 32,
  CONVENTION_EMPLOI = 33,
  CONVENTION_MIROIR = 34,
  CRENEAU = 35,
  DASHBOARD_WIDGET = 161,
  DECLARATION_FNAS = 130,
  DELIVERY = 122,
  DEMANDE_AFFILIATION = 128,
  DIALOG = 36,
  DOCUMENT = 37,
  DOCUMENT_CATEGORY = 103,
  DOCUMENT_TYPE = 102,
  DPAE = 38,
  DPAE_MASSE_RESULT = 176,
  DSN = 123,
  DSN_CERTIFICAT = 140,
  DSN_SYNTHESE = 141,
  ECRITURE_GENERALE_MOIS = 148,
  ECRITURE_GENERALE_RATTRAPAGE = 168,
  EDU_SIGN = 166,
  EMAIL = 39,
  EMPLOI = 40,
  EMPLOI_GUSO = 41,
  ETABLISSEMENT = 42,
  ETABLISSEMENT_SALARIE = 43,
  FILES = 44,
  FORME_JURIDIQUE = 45,
  FORMULAIRE_A1 = 160,
  FRACTION_DSN = 98,
  FRAIS = 145,
  GRAPH = 46,
  GRAPH_DATA = 47,
  GRAPH_GRID = 48,
  GRAPH_METIER = 99,
  GRAPH_QUESTION = 49,
  GRAPH_RULE = 50,
  GRAPH_SOLUTION = 51,
  GRAPH_VALUE = 52,
  GROUPE_RETENUE = 53,
  HTML_ATTRIB = 54,
  HTTP_DATA = 55,
  IMAP_CONFIG = 127,
  JOURNAL_PAIE_ANNEE = 56,
  JOURNAL_PAIE_MOIS = 57,
  LIEU = 106,
  LIST_CHOIX = 113,
  LIST_CONFIG = 112,
  LIST_DATA = 111,
  LIST_FILTER = 115,
  LOG = 125,
  MAIL = 58,
  MANDAT_B2B = 157,
  MANDAT_B2C = 156,
  MANUAL_BILLING_DOCUMENT = 175,
  META_ATTRIB = 100,
  MODULE = 108,
  NOTIF = 59,
  NOTIF_DEF = 126,
  NUMERO = 60,
  NUMERO_OBJET = 117,
  OBJET_METIER = 139,
  OODRIVE = 154,
  OODRIVE_DATA = 155,
  OWNER = 120,
  PAIE = 61,
  PARAMETER = 104,
  PAYBOX_TRANSACTION = 169,
  PAYMENT_MEANS = 62,
  PAYMENT_TARGET = 181,
  PAYS = 63,
  PLAGE_CRENEAU = 64,
  PLAN_COMPTABLE = 162,
  POLE_EMPLOI_STATUT = 65,
  PROJET = 66,
  PUBLI_PARAM = 67,
  QUALITE = 68,
  REASON = 143,
  REASON_DEF = 142,
  REASON_SELECT = 144,
  RECAP_CHARGES_ANNEE = 69,
  RECAP_CHARGES_MOIS = 70,
  RECAP_PAS_EMPLOYEUR_ANNEE = 71,
  RECAP_PAS_EMPLOYEUR_MOIS = 72,
  RECAP_PAS_SALARIE_ANNEE = 151,
  REDUCTION_GENERALE_ANNEE = 150,
  REFUNDABLE = 170,
  REGISTRE_PERSONNEL_MOIS = 73,
  REPAY = 146,
  REPORT = 74,
  RESPONSE_MESSAGE = 131,
  RESSOURCE = 75,
  RESULTAT_CONTRAT_MASSE = 180,
  RETENUE = 76,
  REUSABLE = 171,
  RIB = 77,
  ROUTE = 78,
  RUBRIQUE = 79,
  SALARIE = 80,
  SESSION = 81,
  SHORT_URL = 129,
  SIMULATION = 101,
  SIRET_INSCRIPTION = 87,
  SMS = 82,
  SOCIETE = 83,
  SSO = 149,
  STAT_CLIENT = 158,
  STATE = 84,
  STATUS = 85,
  SUBSCRIPTION = 86,
  SUBSCRIPTION_TYPE = 88,
  SUPPORT = 89,
  SYNCHRO98 = 167,
  TAXE_SALAIRES_ANNEE = 152,
  TEST_PAIE = 105,
  TRANCHE_EFFECTIF = 90,
  TRANSACTION = 91,
  TRANSACTION_LIST = 134,
  TUILE = 92,
  URSSAF = 93,
  USER = 94,
  WIZARD = 95,
  WIZARD_ITEM = 107,
};
